const resetStepIndex = state => {
  state.stepIndex = 0;
};

const setStepIndex = (state, stepIndex) => {
  if (stepIndex > state.stepIndex) {
    state.stepIndex = stepIndex;
  }
};

export default {
  resetStepIndex,
  setStepIndex,
};
